import commonAnnotationTools from './annotations/commonAnnotationTools';
import pageProperties from './pageProperties';

/**
 * ** NOTE ** Operates outside the react lifecycle
 * Grabs the extra information required to scroll an annotation into view and preforms
 * the scroll operation.
 * @param {Object} annotation - The selected annotation to scroll into view
 * @param {String} annotation.rectString - The selection area for the annotation
 * @param {Number} annotation.pageNumber - The page the annotatoin is rendered on
 */
const scrollIntoView = annotation => {
  // Fetch the required data from the pageElement
  const {
    scale,
    pageHeight,
    offset,
    dpiScale,
    pageElement
  } = pageProperties.getCanvasProperties(annotation.pageNumber);
  // Create the annotation
  const [box] = commonAnnotationTools.adaptPDFRects(scale, pageHeight, annotation, offset, true);
  const adjustedX = box.x / dpiScale;
  const adjustedY = box.y / dpiScale;
  const adjustedW = box.w / dpiScale;
  const adjustedH = box.h / dpiScale;

  // Scroll to the page the annotation is on
  pageElement.scrollIntoView();

  // Get the pdf viewer window div, see what the distance from top is after scrolling
  const elem = global.document.getElementById('pdf-viewer-body');
  const pageDistanceFromTop = elem.scrollTop;
  const pdfViewportYCenter = elem.clientHeight * 0.5;
  const pdfViewportXCenter = elem.clientWidth * 0.5;

  // Distance from top + y coord from top of page + 1/2 of box height - half the viewport height
  const scrollFromTop = pageDistanceFromTop + adjustedY + 0.5 * adjustedH - pdfViewportYCenter;

  // X coord from left + 1/2 box width - half the viewport width
  const scrollFromLeft = adjustedX + 0.5 * adjustedW - pdfViewportXCenter;
  elem.scrollTop = scrollFromTop;
  elem.scrollLeft = scrollFromLeft;
};
const scrollAnnotationIntoView = annotation => {
  // in some circumstances (ie when zoomed changed while viewing a page that does not show the
  // selection) the scroll into view method may be referencing an out of date `pdf-viewer-body`
  // scroll to the approximate location then scrolling again gets around this problem.
  // In all other instance attempting to scroll again will result in no action.
  scrollIntoView(annotation);
  setTimeout(() => {
    scrollIntoView(annotation);
  }, 20);
};
export default {
  scrollAnnotationIntoView
};